import React from "react";
import restService from "../../restService";

const Logout = () => {
  const handleLogout = () => {
    sessionStorage.clear();
    restService.Auth.redirectToAuth();
  };

  return (
    <div
      className="absolute bottom-5 flex items-center py-4 my-3 hover:font-bold text-[#ff0000] cursor-pointer ml-10"
      onClick={handleLogout}
    >
      <img
        src={require("../../assets/images/logout.svg")}
        alt=""
        className="mr-3"
      />
      Logout
    </div>
  );
};

export default Logout;
